import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { HttpClient } from '@angular/common/http';
import { Observable, combineLatest, forkJoin } from 'rxjs';
import { environment } from 'src/environments/environment';
/**
 * The Servie to load the Legaldata for the Mandant
 */
@Injectable({
  providedIn: 'root'
})
export class LegalService {
  /**
   * constructor for the LegalService
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) {

  }
  /**
   * Update an Legalfile
   * @param name 
   * @param content 
   * @returns 
   */
  updateLegalFile(name, content) {
    const clientId = this.environment.getClientId();
    const body = {
      clientRef: clientId,
      content: content,
      originalFilename: `${clientId}_${name}.html`,
      publicId: `${clientId}_${name}`,
      type: 'text/html'
    }
    return this.http.post(`${this.environment.getApiUrl()}/attachment/${clientId}_${name}/file`, body);
  }
  /**
   * Get a Legalfile
   * @returns 
   */
  getLegalFiles() {
    const clientId = this.environment.getClientId();
    const files = ['participation', 'privacy', 'about', 'contact'];
    const requests = files.map(file => {
      return this.http.get(`${this.environment.getApiUrl()}/attachment/${clientId}_${file}/file`,
        { responseType: 'text' });
    })
    return combineLatest(requests);
  }


  /**
  /**
 * Get the About file for the current Client
 */
  getAbout(): Observable<any> {
    return this.http.get(`${this.environment.getApiUrl()}/attachment/${environment.clientID}_about/file`, { responseType: 'text' })
  }

  /**
   * Get the Participation file for the current Client
   */
  getParticipation(): Observable<any> {
    return this.http.get(`${this.environment.getApiUrl()}/attachment/${environment.clientID}_participation/file`, { responseType: 'text' })
  }

  /**
   * Get the Privace file for the current Client
   */
  getPrivacy(): Observable<any> {
    return this.http.get(`${this.environment.getApiUrl()}/attachment/${environment.clientID}_privacy/file`, { responseType: 'text' })
  }


  /**
 * Get the Contact file for the current Client
 */
  getContact(): Observable<any> {
    return this.http.get(`${this.environment.getApiUrl()}/attachment/${environment.clientID}_contact/file`, { responseType: 'text' })
  }
}
